import { ProgressBar, Icon, IconName } from '@ets/design-system';

import { FormattedMessage } from 'react-intl';

import style from './Loading.module.scss';

type LoadingProps = {
  message: TranslationMessage;
  icon?: IconName;
};

const Loading = ({ message, icon }: LoadingProps) => {
  return (
    <div className={style.loading}>
      {icon && (
        <div className={style.icon}>
          <Icon icon={icon} size="12" testId={icon} color="primary" />
        </div>
      )}
      <ProgressBar variant="primary-dark" size="m" testId="users-loading">
        <FormattedMessage id={message.id} values={message.values} />
      </ProgressBar>
    </div>
  );
};

export default Loading;
